import i18n from '@dms/i18n';

import {Field} from './primitives/Field';

/**
 * Date picker component for displaying the calculated next service inspection date of a vehicle.
 * This field is typically calculated automatically based on the last service inspection date and service inspection interval.
 * Used in service interval tracking to show when a service inspection should be performed next.
 */
export function NextServiceInspectionDatePicker() {
  return (
    <Field
      type="apiDate"
      name="serviceIntervals.serviceInspection.nextServiceInspectionDate"
      label={i18n.t('entity.vehicle.labels.dateOfNextServiceInspection')}
    />
  );
}
